import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=64603e7c"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64603e7c')) {
      api.createRecord('64603e7c', component.options)
    } else {
      api.reload('64603e7c', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=64603e7c", function () {
      api.rerender('64603e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/Wrapper.vue"
export default component.exports